import * as React from 'react';
import {useEffect, useState} from "react";

const TextField = (field) => {
  const [fieldValue, setFieldValue] = useState(field.value)

  
  useEffect(() => {
    if (field.value !== fieldValue) {
      setFieldValue(field.value);
    }
  }, [field.value]);

  const onChange = (evt) => {
    setFieldValue(evt.target.value);
  };

  const onBlur = (evt) => {
    let val = evt.target.value || "";
    if(field.hasOwnProperty("toUpperCase") && field.toUpperCase){
        val = val.toUpperCase();
    }
    if(field.hasOwnProperty("toLowerCase") && field.toLowerCase){
        val = val.toLowerCase();
    }
    field.onChange({
        target: {
          name: field.name,
          value: field.widget === "integer" ? parseInt(val, 10) : (field.widget === "float" ? parseFloat(val) : val),
        }
      }
    );
  }

  const props = {
    ...field,
    type: field.widget === "integer" || field.widget === "float" ? "number" : (field.widget == "textfield" ? "text" : field.widget),
    value: fieldValue,
    onChange,
    onBlur,
    onFocus: onBlur
  }
  if(field.hasOwnProperty("shrinked") && field.shrinked){
    delete props.shrinked
    props.InputLabelProps = { shrink: true }
  }
  if(field.hasOwnProperty("toUpperCase") && field.toUpperCase){
    delete props.toUpperCase
    props.inputProps = { style: { textTransform: "uppercase" } }
  }
  if(field.hasOwnProperty("toLowerCase") && field.toLowerCase){
    delete props.toLowerCase
    props.inputProps = { style: { textTransform: "lowercase" } }
  }

  const helperText = props.helperText
  delete props.emoji;
  delete props.tags;
  delete props.globalStatus;
  delete props.superGlobalStatus;
  delete props.helperText;


  return <div className="input-form">
        <label>{props.label} {props.required && !props.disabled ? '*' : ''}</label>
        <div className='form-group'>
            {field.widget === "textarea" ?
            <textarea
              {...props}></textarea> :  <input {...props} />
            }           
            {helperText && (
              <div className={`helper-text ${props.error ? 'error' : ''}`}>
                {helperText}
              </div>
            )}
          </div>
        
          </div>;

}


export default TextField;
